var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v(_vm._s(_vm.columnDefinition.mapValue(_vm.columnData[_vm.columnDefinition.name], _vm.columnData)))])
}
var staticRenderFns = []

export { render, staticRenderFns }